import { Box, Chip, styled } from "@material-ui/core";
import { last } from "lodash";
import { useState, useEffect } from "react";
import AmsChip from "../../atoms/AmsChip/AmsChip";
import AmsProductCount from "../../atoms/AmsProductCount/AmsProductCount";
import "./amsproductlist.css";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import AmsButton from "../../atoms/AmsButton/AmsButton";
import { cubesheetData, roomMapObj } from "../../utils/cubeSheetList";
import { generateItemId, isObjectEmpty } from "../../utils/helpers";

const addItemBtnProps = {
  attributes: {
    id: "addItem",
    name: "addItemBtn",
    label: "Add Item",
    className: "amsButtonGreenRound",
  },
};

const TextFieldRef = styled(TextField)({
  "& .MuiInput-underline:after": {
    borderBottom: "2px solid red !important"
  },


}) as typeof TextField;

const AmsProductList = (props: any) => {
  const { list, roomType, currentRoom } = props;

  const [listItems, setListItems] = useState<any>(list || []);
  const [selectedProduct, setSelectedProduct] = useState<any[]>([]);
  const [extraItems, setExtraItems] = useState<any>([]);
  const [selectedExtraItem, setSelectedExtraItem] = useState<any>({});
  const [selectedExtraItemList, setSelectedExtraItemList] = useState<any>([]);

  useEffect(() => {
    let roomInfo: any = sessionStorage.getItem(`roomInfo`);

    if (roomInfo) {
      roomInfo = JSON.parse(roomInfo);
      let room: any = roomInfo.find((obj: any) =>
        obj.hasOwnProperty(`${roomType}`)
      );

      let quantityPresent = room[`${roomType}`]?.filter(
        (item: any) => item?.quantity > 0
      );

      let quantityNotPresent = room[`${roomType}`]?.filter(
        (item: any) => item?.quantity === 0
      );

      setSelectedProduct(quantityPresent);
      setListItems(quantityNotPresent);
    }

    let additionalItems = JSON.parse(cubesheetData);

    let additionalRoomKey = roomMapObj[`${currentRoom}`];

    let additionalRoomData = additionalItems.find(
      (item: any) => item?.CubeName === additionalRoomKey
    )?.CubeSheetItemTypeDetails;


    setExtraItems(additionalRoomData);
  }, []);

  const updateRoomInfo = (allRooms: any, selectedRoom: any, roomType: any) => {
    // Find the "Bedroom" object in myArr
    const roomObject = allRooms.find((obj: any) =>
      obj.hasOwnProperty(`${roomType}`)
    );

    if (roomObject) {
      // Update the "Bedroom" array in bedroomObject
      roomObject[`${roomType}`].forEach((roomItem: any, index: any) => {
        const matchingNewItem = selectedRoom.find(
          (newItem: any) => newItem.index === roomItem.index
        );
        if (matchingNewItem) {
          roomObject[`${roomType}`][index] = matchingNewItem;
        }
      });
    }

    return allRooms;
  };

  useEffect(() => {
    const newArr = [...selectedProduct, ...listItems];
    let roomInfo: any = sessionStorage.getItem(`roomInfo`);

    if (roomInfo) {
      roomInfo = JSON.parse(roomInfo);
      const newRoomInfo = updateRoomInfo(roomInfo, newArr, roomType);
      sessionStorage.setItem("roomInfo", JSON.stringify(newRoomInfo));
    }
  }, [selectedProduct]);

  const handleItemClick = (index: number) => {
    let listArr = [...listItems];
    let product = listArr.filter((item) => item?.index === index)[0];
    product["quantity"] = 1;
    listArr = listArr.filter((item) => item?.index !== index);
    setListItems([...listArr]);
    setSelectedProduct((selectedProduct) => [...selectedProduct, product]);
  };

  const handleDecrement = (index: any, count: any) => {
    let productList: any = [...selectedProduct];
    if (count > 1) {
      productList.map((item: any) => {
        if (item?.index === index) {
          item["quantity"] = item["quantity"] - 1;
        }
      });
      setSelectedProduct(productList);
    } else {
      //adding the element removed from selected product into the list item again
      let lastCount = productList.filter(
        (item: any) => item?.index === index
      )[0];
      lastCount["quantity"] = 0;
      let newList = [...listItems];
      newList.push(lastCount);
      setListItems(newList);
      //removing the element from selected product list when it's count is 0
      let newProduct = [...productList];
      newProduct = newProduct.filter((item: any) => item?.quantity !== 0);
      setSelectedProduct(newProduct);
    }
  };

  const handleIncrement = (index: any, count: any) => {
    let productList = [...selectedProduct];
    productList.map((item: any) => {
      if (item?.index === index) {
        item["quantity"] = item["quantity"] + 1;
      }
    });
    setSelectedProduct(productList);
  };

  const handleChange = (value: any) => {
    console.log("Handle change : ", value);

    //creating the additional Item structure similar to inventory items
    let newSelectedItem = {
      ...value,
      item: value?.item,
      quantity: 1,
      text: value?.item,
      index: 2,
      cubes: value?.cubes,
      itemId: generateItemId(),
      room: roomType,
      isAdditionaItem: true,
    };

    setSelectedExtraItem(newSelectedItem);
  };

  const addItem = () => {
    //we will push the selected Extra Item from the additional item list,

    if (!isObjectEmpty(selectedExtraItem)) {
      setSelectedExtraItemList((prevItems: any) => [
        ...prevItems,
        selectedExtraItem,
      ]);
    }
  };

  useEffect(() => {
    if (selectedExtraItemList.length > 0) {
      // Create a set of items in selectedItemList for faster lookup
      const selectedItemListSet = new Set(
        selectedExtraItemList.map((el: any) => el.item)
      );

      // Filter extraItems to keep only the items that are not in selectedItemListSet
      const filteredExtraItems = extraItems.filter(
        (el: any) => !selectedItemListSet.has(el?.CubeSheetName)
      );

      //console.log("selectedItemListSet : ",selectedItemListSet,filteredExtraItems)

      setExtraItems(filteredExtraItems);
      setSelectedExtraItem({});

      //save selectedExtraItemList in session storage

      let savedAdditionalList: any = sessionStorage.getItem("additionalItems");

      if (savedAdditionalList) {
        savedAdditionalList = JSON.parse(savedAdditionalList);

        let additionItemByRoom = {
          [roomType]: selectedExtraItemList,
        };

        
        savedAdditionalList[roomType] = additionItemByRoom[roomType];
        sessionStorage.setItem(
          "additionalItems",
          JSON.stringify(savedAdditionalList)
        );
      } else {
        let additionItemByRoom = {
          [roomType]: selectedExtraItemList,
        };
        sessionStorage.setItem(
          "additionalItems",
          JSON.stringify(additionItemByRoom)
        );
      }
    }
  }, [selectedExtraItemList]);

  const handleExtraItemDecrement = (roomItem: any) => {
    let quantity = roomItem["quantity"] - 1;

    //if quantity is greater than zero simply add the quantity to the selected item
    if (quantity > 0) {
      const newSelectedExtraItemList = selectedExtraItemList.map(
        (item: any) => {
          if (item?.itemId === roomItem?.itemId) {
            item["quantity"] = quantity;
          }
          return item;
        }
      );

      setSelectedExtraItemList(newSelectedExtraItemList);
    } else {
      //if quantity is zero
      //1. remove the item from selected List
      const FilteredExtraItemList = selectedExtraItemList.filter(
        (item: any) => item?.itemId !== roomItem?.itemId
      );

      setSelectedExtraItemList(FilteredExtraItemList);

      //2. Add the item back to the additional list
      let newExtraItem = {
        ID: roomItem?.ID,
        CubeSheetName: roomItem?.CubeSheetName,
        CubesheetItemTypeID: roomItem?.CubesheetItemTypeID,
        Cube: roomItem?.Cube,
        defaultItem: roomItem?.defaultItem,
      };

      setExtraItems((prevItems: any) => [newExtraItem, ...prevItems]);
    }
  };

  const handleExtraItemIncrement = (roomItem: any) => {
    let quantity = roomItem["quantity"] + 1;
    const newSelectedExtraItemList = selectedExtraItemList.map((item: any) => {
      if (item?.itemId === roomItem?.itemId) {
        item["quantity"] = quantity;
      }
      return item;
    });

    setSelectedExtraItemList(newSelectedExtraItemList);
  };

  return (
    <Box className="productList">
      <Box mb={5} mt={5} className="listItems">
        {listItems.length > 0 &&
          listItems?.map((item: any, index: any) => {
            return (
              <AmsChip
                className="singleProduct"
                itemClick={() => handleItemClick(item?.index)}
                text={item?.text}
                key={index}
              />
            );
          })}
      </Box>
      <Box
        mt={5}
        mb={5}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"center"}
        flexDirection={"column"}
      >
        <Autocomplete
          id={"autoComplete"}
          freeSolo
          options={extraItems}
          getOptionLabel={(option: any) => option?.item}
          style={{ width: 200 }}
          onChange={(event: any, newValue: any) => handleChange(newValue)}
          renderInput={(params) => (
            <TextFieldRef
              {...params}
              label="Add Additional Items"
              //variant="outlined"
              
              className="inputStyle"
                InputProps={{
                  ...params.InputProps,
                  className: "zipAddressInput"
                }}
                InputLabelProps={{
                  className: 'zipLabelstyles'
                }}
                autoFocus={false}
                aria-describedby={`error-text`}
              
            />
          )}
        />
        <Box mt={3} width={"150px"}>
          <AmsButton
            attributes={addItemBtnProps?.attributes}
            handleClick={addItem}
          />
        </Box>
      </Box>

      <Box mb={5} mt={5} className="product">
        {selectedProduct?.map((item: any, index: any) => {
          return (
            <AmsProductCount
              count={item?.quantity}
              onDecrementClick={() =>
                handleDecrement(item?.index, item?.quantity)
              }
              onIncrementClick={() =>
                handleIncrement(item?.index, item?.quantity)
              }
              className="singleProductCount"
              text={item?.text}
              index={item?.index}
              key={index}
            />
          );
        })}
      </Box>
      <Box className="product">
        <div>{"Additional Items"}</div>
        {selectedExtraItemList?.map((item: any, index: any) => {
          return (
            <AmsProductCount
              count={item?.quantity}
              onDecrementClick={() => handleExtraItemDecrement(item)}
              onIncrementClick={() => handleExtraItemIncrement(item)}
              className="singleProductCount"
              text={item?.text}
              index={item?.index}
              key={index}
            />
          );
        })}
      </Box>
    </Box>
  );
};

export default AmsProductList;
